import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  canAccessAdminPath,
  getPostLoginRoute,
} from '../constants/admin-access.constants';
import { AuthSessionService } from '../services/auth-session.service';

@Injectable({ providedIn: 'root' })
export class AdminRoleGuard implements CanActivate {
  constructor(
    private session: AuthSessionService,
    private router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.session.ready().pipe(
      map((profile) => {
        if (!profile) {
          return this.router.createUrlTree(['/login']);
        }
        if (canAccessAdminPath(profile.role, state.url)) {
          return true;
        }
        const home = getPostLoginRoute(profile.role, profile.isApproved);
        const current = state.url.split('?')[0];
        if (current === home) {
          return true;
        }
        return this.router.createUrlTree([home]);
      }),
    );
  }
}
